module.exports = __webpack_public_path__ + "img/case.02dac2ec.svg";